import { mtc } from '../../../utils/style-helpers'
import { styles } from './styles'

export interface ImageProps {
  src: string
  /** Defines text that can replace the image in the page. */
  alt: string
  width?: number | string
  height?: number | string
  className?: string
  /** Indicates how the browser should load the image | Default lazy */
  loading?: 'lazy' | 'eager'
  aspectRatio?: '1/1' | '4/3' | '16/9'
  /** Sets how image will be resized to fit its container */
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scaleDown'
  onLoad?: () => void
}

export const Image = ({
  src,
  alt,
  width,
  height,
  className,
  loading = 'lazy',
  aspectRatio,
  objectFit = 'cover',
  onLoad,
}: ImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      onLoad={onLoad}
      className={mtc(
        styles({
          aspectRatio,
          objectFit,
        }),
        className
      )}
    />
  )
}

Image.displayName = 'Image'
